import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=6cf44876&scoped=true&"
import script from "./NumberView.vue?vue&type=script&lang=js&"
export * from "./NumberView.vue?vue&type=script&lang=js&"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=6cf44876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf44876",
  null
  
)

export default component.exports